import { z } from 'zod';
import { MIN_PASSWORD_LENGTH } from './constants';
export const passwordValidator = z
    .string()
    .min(MIN_PASSWORD_LENGTH, 'SIGN_UP_PAGE.PASSWORD_MIN_LENGTH_ERROR')
    .describe('User password');
export const emailValidator = z
    .string()
    .email('INVALID_EMAIL_FORMAT')
    .min(1, 'REQUIRED_INPUT')
    .describe('User Email');
export const usernameValidator = z.string().min(1, 'REQUIRED_INPUT').describe('User Name');
export const integerIdValidator = z
    .number()
    .int('INVALID_ID')
    .min(1, 'INVALID_ID')
    .describe('Integer ID');
export const verificationCodeValidator = z
    .string()
    .length(5, 'INVALID_VERIFICATION_CODE')
    .regex(/^\d{5}$/, 'INVALID_VERIFICATION_CODE')
    .describe('Verification code (5 number string)');
//# sourceMappingURL=common.js.map